import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "call-made",
  "use": "call-made-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"call-made\"><path d=\"M9 5v2h6.59L4 18.59 5.41 20 17 8.41V15h2V5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol